<script setup lang="ts">
    interface MemberSliderProps {
        data: MemberSliderData;
        sequence: MemberSlideData[];
    }

    const props = defineProps<MemberSliderProps>();
</script>
<template>
    <mol-section
        :intro="data.intro"
        :background-image="data.style.background_image"
        :background-image-mobile="data.style.background_image_mobile"
        class="org-member-slider">
        <mol-content-slider
            :slide-data="sequence"
            v-slot="{ data }">
            <atm-account-card class="h-full">
                <atm-heading
                    :font-bold="false"
                    level="h3"
                    size="lg"
                    class="rotate-[-8deg] pt-2 pb-8 font-display leading-[90%]">
                    {{ data.title }}
                </atm-heading>
                <p class="text-sm">{{ data.description }}</p>
            </atm-account-card>
        </mol-content-slider>
    </mol-section>
</template>
<style scoped>
    @reference "#main.css";
    .org-member-slider :deep(h2) {
        @apply heading-member;
    }
</style>
